import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LayoutContainer from 'components/layout/layout';
import getText from 'context/language/getText';
import { Alert, alertTypes } from 'components/common/alerts';
import { error } from 'analytics/utilities';
import SEGMENT from 'constants/segment';

export const ProfileContent = props => <LayoutContainer {...props} />;

export const ProfileError = () => {
  useEffect(() => {
    error(SEGMENT.ERROR)({ label: SEGMENT.TYPES.LOAD_USER_ERROR });
  }, []);
  return <Alert type={alertTypes.ERROR} content={getText('loading.noCurrentUser')} />;
};

export const Profile = ({ showError, ...restProps }) => {
  if (showError) {
    return <ProfileError />;
  }
  return <ProfileContent {...restProps} />;
};

Profile.propTypes = {
  showError: PropTypes.bool.isRequired,
};

export default Profile;
